window._define('widgets/selectValue', ['jquery', 'widgets/baseWidget'], function ($, BaseWidget) {
    'use strict';

    var widgetName = 'selectValue',
        jsClassName = 'js-selectValue',
        KEY_C = 67,
        KEY_X = 88;

    // widget definition
    $.widget('OC.' + widgetName, BaseWidget, {
        options: {
            onFocus: $.noop,
        },

        _create: function () {

            this._super(jsClassName);

            this.elements.$input = this.element;

            this._addEvents();
        },

        _addEvents: function () {
            var self = this;

            this.element
                .on('focus, click', function () {
                    $(this).select();

                    self._trigger('onFocus');
                })
                .on('keydown', function (event) {
                    // if NOT ctrl-c ctrl-x cmd-c cmd-x
                    if (!((event.metaKey || event.ctrlKey) && (event.keyCode === KEY_C || event.keyCode === KEY_X))) {
                        event.preventDefault();
                    }
                });
        },
    });

    $('.' + jsClassName)[widgetName]();

    return $.OC[widgetName];
});
